import { render, staticRenderFns } from "./FormMultiselect.vue?vue&type=template&id=511b13a6&scoped=true&"
import script from "./FormMultiselect.vue?vue&type=script&lang=js&"
export * from "./FormMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./FormMultiselect.vue?vue&type=style&index=0&id=511b13a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511b13a6",
  null
  
)

export default component.exports